import PropTypes from "prop-types";
import { forwardRef } from "react";

import styled from "styled-components/macro";

const Image = forwardRef(({ url }, forwardedRef) => {
  const applyShadow = !String(url).endsWith(".png"); // skip shadow for PNGs in case using transparency

  return (
    <Wrapper className="image" ref={forwardedRef} $applyShadow={applyShadow}>
      <ImageEl src={url} />
    </Wrapper>
  );
});

Image.propTypes = {
  url: PropTypes.string,
};

export default Image;

const Wrapper = styled.div`
  width: 100%;
  border-radius: 6px;
  grid-area: video;
  align-self: center;
  box-shadow: ${({ $applyShadow }) =>
    $applyShadow ? "rgba(0, 0, 0, 0.4) 1px 1px 8px" : null};
  order: 2;
`;
const ImageEl = styled.img`
  border-radius: 6px;
  overflow: hidden;
  max-height: 600px;
  width: 100%;
  box-sizing: border-box;
  border: none;
  display: block;
  flex-grow: 0;
  flex-shrink: 0;
  object-fit: cover;
`;
